<template>
  <div class="col-options-data-dialog">
    <el-collapse v-model="activeNames">
      <el-collapse-item
        @mousedown.native="collapseMouseDown($event, '1')"
        title="显示设置"
        name="1"
        class="padding0"
      >
        <!-- <div class="content" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '1')">
          <div class="content-item">
            <slider-and-input
              class=""
              :value.sync="bottomHeight"
              title="底栏高度"
              :sliderMax="500"
              :sliderMin="0"
              suffix="px"
            />
          </div>
        </div> -->
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import {
  findTabs,
  replaceUrlParam,
  handleFindLayoutComponentBoxOptions,
  handleFindLayoutComponentAllUid,
  checkIrregularLayout,
} from "utils"
import { layout_title_drawer_button_children } from "materials/button/menus"
import {
  createSubPageHandle,
  updateSubPageMapping,
  addSubPageMapping
} from "utils/updateData/publicDataUtils/subPageUpdateData.js"
export default {
  props: {
    options: { type: Object },
    container_id: { type: [Number, String] },
    rect_id: { type: [Number, String] }
  },
  watch: {
  },
  data() {
    return {
      this1: this,
      activeNames: ["1", "2", "3", "4"],
      collapseActiveNames: ["1", "2", "3", "4"],
      drawerSelectOptions: [
        {
          label: "页面",
          value: true
        },
        {
          label: "组件",
          value: false
        }
      ],
      collapse: {
        top: {
          title: "标题栏",
          type: "top",
          isActive: true
        },
        bottom: {
          title: "底部栏",
          type: "bottom",
          isActive: true
        },
        left: {
          title: "左侧栏",
          type: "left",
          isActive: true
        },
        right: {
          title: "右侧栏",
          type: "right",
          isActive: true
        },
        list: {
          title: "列表页",
          type: "list",
          isActive: true
        },
        detail: {
          title: "详情页",
          type: "detail",
          isActive: true
        },
        advanced: {
          title: "数据设置",
          type: "advanced",
          isActive: true
        },
        order: {
          title: "自定义数据顺序",
          type: "order",
          isActive: true
        }
      }, // 用来存放当前数据组和图例设置里面的展开收起状态
      collapseDataActiveNames: ["0", "1", "2", "3", "4", "5", "6", "7"],
      // 用户配置项回显 // 先给一个默认值
      titleComponents: [
        {
          directionIndex: 1,
          elementOptions: [
            {
              type: "pagination",
              title: "显示分页",
              elementInLayoutId: 2,
              isShow: true,
              disabled: false
            }
          ]
        }
      ],
      listPageData: {},
      detailPageData: {},
      showNavMenu: true,
      showApplicationName: true,
      showSearchComponent: true,
      showBreadCrumbs: true,
      currentListPageCover: "",
      currentListPageTitle: "",
      currentDetailPageCover: "",
      currentDetailPageTitle: "",
      publicId: null,
      subPageSettingIndex: 0,
      explainDialog: false,
      explainTitle: "",
      explainTips: "",
      explainImgSrc: "",
      explainVideoSrc: "",
      isListPageEditStatus: false,
      isDetailPageEditStatus: false,
      getAllTabsIsCheckedAll: false,
      allTabsIsCheckedAll: false,
      allTabs: [],
      bottomPaginationShow: false,
      showDialogForDataPush: false,
      interfacePushRule: {
        addAndUpdateRule: "", //1表示新增时，2表示修改时
        engineInstanceId: this.options.engineInstanceId_10, //对应应用的engineInstanceId
        id: null, //有则修改，为空为新增
        method: 0, //0表示全部数据，1表示置顶数据
        pushType: "1", //推送置接口固定为1
        status: this.options.openDataPush, //true开启推送，false关闭
        url: ""
      },
      editDataToPush: false,
      newDataToPush: false,
      navAllDataEmpty: false
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    getOptions: function () {
      if (this.ids.elementInAutoLayoutId !== undefined) {
        return this.getAttrById(this.$store.state[this.request_prefix], this.ids, "elementInAutoLayout")
      }
      return this.getRectAttribute.call(this, this.ids).options
    },
    // bottomHeight: {
    //   get() {
    //     return this.checkAndSetPrimaryVal(this.options.titleOptions[0], "height", "height", 60)
    //   },
    //   set(newVal) {
    //     const completeParam = {
    //       container_id: this.ids.container_id,
    //       rect_id: this.ids.rect_id,
    //       elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
    //       path: this.ids.path,
    //       directionIndex: 0,
    //       changingTitleElement: true
    //     }
    //     this.$changeOptionsEV(newVal, "height", false, false, completeParam)
    //   }
    // }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    collapseMouseDown($event, val) {
      if (
        $event.target.classList[0] === "el-collapse-item__header" ||
        $event.target.classList[0] === "el-collapse-item__arrow"
      ) {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.toolbar .padding0 ::v-deep .el-collapse-item__content {
  padding: 0 16px 0 16px !important;
}
.childPageSettingBtn {
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 13px;
  line-height: 18px;
  text-align: center;
  color: var(--themeColor);
  padding: 5px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  &:not(.disabledBtn):hover {
    background: var(--defaultButtonHover);
    cursor: pointer;
  }
  &.is_disabled {
    background: var(--defaultButtonHover);
  }
  .icon-portal-loading1 {
    display: inline-block;
    margin-right: 4px;
    transform: rotate(90deg);
    font-size: 14px;
    color: var(--topOperationAColor);
    vertical-align: middle;
    margin-top: -2px;
    animation: rotation 1s linear infinite;
    &:before {
      color: var(--topOperationAColor);
    }
  }
  &.disabledBtn {
    cursor: not-allowed;
    border: 1px solid var(--themeColorDisabled);
    color: var(--themeColorDisabled);
  }
}
.layoutConfig-card {
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  .img-box {
    width: 100%;
    // height: 122px;
    box-sizing: border-box;
    background-color: rgba(245, 246, 248, 1);
    background-position: top;
    background-size: contain;
    background-clip: padding-box;
    background-repeat: no-repeat;
    background-size: 100%;
    &[src=""] {
      opacity: 0;
    }
  }
  .footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    padding: 12px;
    gap: 9.13px;
    position: absolute;
    width: 100%;
    height: 42px;
    left: 0px;
    bottom: 0px;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(14.6087px);
    .title {
      font-size: 13px;
      line-height: 18px;
      color: #000000;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: 104px;
    }
    .desc {
      cursor: pointer;
      font-weight: 400;
      font-size: 13px;
      line-height: 18px;
      color: #2b67ff;
      display: flex;
      align-items: center;
    }
  }
  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 4px 4px 4px 12px;
    background: #fbfcfd;
    .title {
      font-weight: 500;
      font-size: 13px;
      line-height: 18px;
      color: rgba(0, 0, 0, 0.8);
    }
    .btn {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #2b67ff;
      cursor: pointer;
    }
  }
  .config-content {
    padding: 12px 12px 0 12px;
    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
    color: rgba(0, 0, 0, 0.8);
    .el-radio {
      margin-top: 0;
      margin-bottom: 0;
      margin-right: 0;
      white-space: pre-wrap;
    }
    .cx-check-box {
      display: inline-block;
    }
    .tips-btn {
      line-height: 20px;
      margin-top: 0;
    }
  }
}
.cover {
  height: 132px;
}
.tips-btn {
  display: inline-block;
  vertical-align: top;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  font-size: 14px;
  color: var(--thirdTextColor);
  margin-left: 2px;
  cursor: pointer;
  border-radius: 4px;
}
.tips-btn:hover {
  color: var(--themeColor);
}
.flex {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.padding8 {
  padding: 8px 4px;
}
.col_li {
  padding: 6px 4px;
}
.col_li .el-checkbox {
  margin-right: 6px;
}
.syncCol_btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 50px;
  height: 28px;
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
}
.push-history-link {
  color: var(--themeColor);
  cursor: pointer;
}
</style>
